declare global {
  interface Window {
    _env_?: Record<string, string>;
  }
}

export function getEnv(key: string, defaultValue: string = ""): string {
  if (typeof window !== "undefined" && window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  return (import.meta.env[key] as string) || defaultValue;
}
